<template>
  <div>
    <div v-for="event in events" :key="event.event_id">
      <v-menu open-on-hover left offset-x>
        <template v-slot:activator="{ on, attrs }">
          <div
            v-bind="attrs"
            v-on="on"
            @click="editEvent(event)"
            :style="`background-color: ${ backgroundColor(event) }; border: ${ border(event) };`"
            style="height: 15px; width: calc(100% - 2px); margin: 1px; border-radius: 3px; cursor: pointer;"
          >
          </div>
        </template>
        <EventExplainer :event="event" />
      </v-menu>
      <div v-if="hitter_changes(event.event_id)" style="width: 100%; height: 2px; border-radius: 4px; background-color: grey;"></div>
    </div>
    <div v-if="!current_event.event_id"><v-icon size="15">mdi-plus</v-icon></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { mapActions } from 'vuex/dist/vuex.common.js';
import EventExplainer from '@/components/analysis/side_events/EventExplainer.vue'
export default {
  props: {
    colorFunc: {
      type: Function,
      required: false
    },
    filterFunc: {
      type: Function,
      required: false
    },
    filterEvents: {
      type: Function,
      required: false
    }
  },
  components: {
    EventExplainer
  },
  computed: {
    ...mapGetters({
      events: 'analysis/events',
      current_event: 'analysis/current_event',
    }),
    filteredEvents() {
      if(this.filterFunc) {
        return this.events.filter(this.filterFunc)
      }

      return this.events
    }
  },
  methods: {
    ...mapActions({
      startEditingEvent: 'analysis/startEditingEvent',
      seek: 'player/seek',
    }),
    backgroundColor(event) {
      if(this.colorFunc) {
        return this.colorFunc(event)
      }

      return event.hitting === 'home' ? '#2C57FB' : '#FF0807'
    },
    border(event) {
      if(this.borderFunc) {
        return this.borderFunc(event)
      }

      return (this.chosen(event.event_id) ? '3px' : '0') + ' solid black'
    },
    chosen(event_id) {
      return this.current_event.event_id === event_id
    },
    editEvent(event) {
      this.startEditingEvent(event.event_id)
      this.seek(Math.max(event.starttime - 2, 0))
    },
    next(event_id) {
      const index = this.events.findIndex(event => event.event_id === event_id)
      if (index < this.events.length - 1) {
        return this.events[index + 1]
      }
      return null
    },
    previous(event_id) {
      const index = this.events.findIndex(event => event.event_id === event_id)
      if (index > 0) {
        return this.events[index - 1]
      }
      return null
    },
    me(event_id) {
      return this.events?.find(event => event.event_id === event_id)
    },
    hitter_changes(event_id) {
      const me = this.me(event_id)
      const next = this.next(event_id)

      if (me && next) {
        return me.plate_appearance_id !== next.plate_appearance_id
      } else {
        return false
      }
    }
  }
}
</script>
